import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React, {ReactElement} from "react";

type BannerState = {
  isVisible: boolean;
  status?: "success" | "error" | "warning" | "info";
  message?: string | React.ReactNode;
  header?:string;
  className?:string;
};

const initialState: BannerState = {
  isVisible: false,
};

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    showBanner: (
      state,
      action: PayloadAction<{
        status: "success" | "error" | "warning" | "info";
        message: string|  React.ReactNode;
        header?:string;
        className?:string;
      }>,
    ) => {
      state.isVisible = true;
      state.message = action.payload.message;
      state.status = action.payload.status;
      state.header= action.payload.header;
      state.className=action.payload.className;
    },
    hideBanner: (state) => {
      state.isVisible = false;
      state.message = undefined;
      state.status = undefined;
      state.header= undefined;
      state.className=undefined;
    },
  },
});

export const { showBanner, hideBanner } = bannerSlice.actions;
export default bannerSlice.reducer;
